import React from 'react';
import { experiences } from '../../data';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';
import { cardHover, fadeUp, stagger, viewport } from '../motion';

function Experience() {
  return (
    <section id="experience" className="py-20 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-slow"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-medium"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading eyebrow="Where I've worked" title="Experience" className="mb-16" />

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
          variants={stagger(0.15)}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
        >
          {experiences.map((experience, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 transition-shadow duration-500 flex flex-col justify-between h-full relative overflow-hidden hover:shadow-2xl"
              variants={fadeUp}
              whileHover={cardHover}
            >
              {/* Top Accent Bar */}
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-blue-600 to-indigo-700"></div>
              
              <div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4">
                  <h3 className="text-2xl font-bold text-gray-800 font-sans">
                    {experience.company}
                  </h3>
                  <span className="inline-block px-3 py-1 text-xs font-semibold text-indigo-700 bg-indigo-50 rounded-full border border-indigo-100 w-fit font-sans">
                    {experience.duration}
                  </span>
                </div>
                
                <h4 className="text-lg font-bold text-blue-600 mb-4 flex items-center gap-2 font-sans">
                  <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                  {experience.role}
                </h4>
                
                <p className="text-gray-600 text-sm leading-relaxed text-justify mt-2 font-sans">
                  {experience.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Experience;
